import axiosClient from "../common/AxiosClient";

import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { showGlobalSnackbar } from "../providers/SnackbarProvider";

export class UploadService {
  static async onUploadFiles(files: File[]): Promise<string[]> {
    if (isEmpty(files)) return [];

    const formData = new FormData();
    files.forEach((file: File) => {
      formData.append("Files", file);
    });

    try {
      const response = await axiosClient.post(`/FileUpload/temp?key=${uuidv4()}`, formData);
      return response.data.uploadIds;
    } catch (error) {
      showGlobalSnackbar((error as any).response.data, "error");
      return [];
    }
  }
}
